module.exports = __webpack_public_path__ + "static/media/delivered.6ecb0898.gif";